/* Homepage v2 + Fit finder. Plain JS, no dependencies. */
(function () {
  'use strict';
  var STORE_KEY = 'strapsicle_fit';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function track(name, data) {
    try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(Object.assign({ event: name }, data || {})); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, data || {}); } catch (e) {}
    /* Clarity custom event (filter by country/device in Clarity) and Shopify customer event (for a custom pixel to forward to GA4) */
    try { if (typeof window.clarity === 'function') window.clarity('event', name + (data && data.hp2_label ? '_' + data.hp2_label : '')); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) {}
  }
  /* which homepage sections do people actually reach? one event per section per page view, when 40% is on screen */
  function initSectionViews() {
    if (!('IntersectionObserver' in window)) return;
    var secs = $$('.shopify-section').filter(function (s) { return /hp2_[a-z]+_/.test(s.id); });
    if (!secs.length) return;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        var m = /hp2_([a-z]+)_/.exec(en.target.id); io.unobserve(en.target);
        track('hp2_section_view', { hp2_label: m ? m[1] : 'unknown' });
      });
    }, { threshold: 0.4 });
    secs.forEach(function (s) { io.observe(s); });
  }
  /* click tracking: any element with data-hp2-ev sends a GA4 event */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-hp2-ev]');
    if (t) track('hp2_click', { hp2_label: t.getAttribute('data-hp2-ev') });
  }, true);
  function saved() { try { return JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(STORE_KEY, JSON.stringify(v)); } catch (e) {} }

  /* ---------- tabs ---------- */
  function initTabs() {
    $$('[data-hp2-tabs]').forEach(function (root) {
      var tabs = $$('[role=tab]', root), panels = $$('[role=tabpanel]', root);
      function select(i, focus) {
        tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === i ? 'true' : 'false'); t.tabIndex = n === i ? 0 : -1; });
        panels.forEach(function (p, n) { p.hidden = n !== i; });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = i;
          if (k === 'ArrowRight') n = (i + 1) % tabs.length;
          else if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          else if (k === 'Home') n = 0;
          else if (k === 'End') n = tabs.length - 1;
          else return;
          e.preventDefault(); select(n, true);
        });
      });
    });
  }

  /* ---------- tap-to-play video (never autoplay, one at a time) ---------- */
  var playing = null;
  function embedUrl(u) {
    var m = /(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]{6,})/.exec(u);
    if (m) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0&playsinline=1';
    m = /vimeo\.com\/(\d+)/.exec(u);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return u;
  }
  function stopPlaying() {
    if (!playing) return;
    var box = playing.box;
    if (playing.el && playing.el.parentNode) playing.el.parentNode.removeChild(playing.el);
    var btn = $('.hp2-vid__play', box); if (btn) btn.hidden = false;
    var img = $('img', box); if (img) img.hidden = false;
    playing = null;
  }
  function initVideos() {
    $$('[data-hp2-vid]').forEach(function (box) {
      var btn = $('.hp2-vid__play', box);
      if (!btn) return;
      btn.addEventListener('click', function () {
        stopPlaying();
        var src = box.getAttribute('data-src'), embed = box.getAttribute('data-embed'), el;
        if (src) {
          el = document.createElement('video');
          el.src = src; el.controls = true; el.playsInline = true; el.autoplay = true; el.setAttribute('playsinline', '');
          el.addEventListener('ended', stopPlaying);
        } else if (embed) {
          el = document.createElement('iframe');
          el.src = embedUrl(embed); el.allow = 'autoplay; fullscreen; picture-in-picture'; el.allowFullscreen = true; el.title = btn.getAttribute('aria-label') || 'Video';
        } else return;
        box.appendChild(el); btn.hidden = true;
        var img = $('img', box); if (img) img.hidden = true;
        playing = { box: box, el: el };
        track('hp2_video_play', { video: btn.getAttribute('aria-label') || '' });
      });
    });
  }

  /* ---------- optional hero video: one muted loop, after idle ---------- */
  function initHeroVideo() {
    var v = $('[data-hp2-herovideo]');
    if (!v || reduce) return;
    var c = navigator.connection || {};
    if (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')) return;
    var go = function () {
      v.src = v.getAttribute('data-src'); v.muted = true;
      v.addEventListener('canplay', function () { v.style.opacity = 1; v.play().catch(function () {}); }, { once: true });
      v.load();
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 4000 }); else setTimeout(go, 2500);
  }

  /* ---------- hero reel: slow auto-advance, short muted loops while in view ---------- */
  function initReel() {
    var reel = $('[data-hp2-reel]');
    if (!reel) return;
    var c = navigator.connection || {};
    var lite = reduce || c.saveData || /(^|-)2g$/.test(c.effectiveType || '');
    var tiles = $$('.hp2-reel__tile', reel);
    if ('IntersectionObserver' in window && !lite) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var v = $('video', en.target); if (!v) return;
          if (en.isIntersecting) {
            if (!v.src) { v.src = v.getAttribute('data-src'); v.muted = true; v.load(); }
            v.play().then(function () { v.classList.add('is-on'); }).catch(function () {});
          } else { v.pause(); }
        });
      }, { root: reel, threshold: 0.6 });
      tiles.forEach(function (t) { io.observe(t); });
    }
    if (lite || tiles.length < 3) return;
    var timer, idle = false;
    function step() {
      if (idle || document.hidden) return;
      var w = tiles[0].offsetWidth + 4, max = reel.scrollWidth - reel.clientWidth;
      reel.scrollTo({ left: reel.scrollLeft + w >= max - 4 ? 0 : reel.scrollLeft + w, behavior: 'smooth' });
    }
    function start() { clearInterval(timer); timer = setInterval(step, 3600); }
    ['touchstart', 'mousedown', 'wheel'].forEach(function (ev) { reel.addEventListener(ev, function () { idle = true; clearInterval(timer); }, { passive: true, once: true }); });
    start();
  }

  /* ---------- fit finder ---------- */
  var DEVICES = {
    kindle: { label: 'Kindle', help: 'Not sure? Find it under Settings › Device info.', video: 'https://www.youtube.com/watch?v=inalO3rhpVY' },
    kobo: { label: 'Kobo', help: 'Not sure? Find it under Settings › Device information.', video: 'https://www.youtube.com/watch?v=7dFwm-nHshQ' },
    ipad: { label: 'iPad', help: 'Not sure? Find it under Settings › General › About › Model name.' }
  };
  var root, sheet, bodyEl, titleEl, stepEl, backBtn, lastFocus, cfgPromise, cfg, state = { step: 1, device: null, model: null, variant: null };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function loadConfig() {
    if (cfgPromise) return cfgPromise;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    cfgPromise = fetch(base + '?sections=hp2-fit-config', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var html = j['hp2-fit-config'] || '', m = /<script type="application\/json" id="hp2-fit-json">([\s\S]*?)<\/script>/.exec(html);
        if (!m) throw new Error('no config');
        cfg = JSON.parse(m[1]); return cfg;
      }).catch(function (e) { cfgPromise = null; throw e; });
    return cfgPromise;
  }

  var POINTS = { kindle: ['Hands-free, one-handed reading', 'No more drops or hand cramps', 'Fits Paperwhite, Colorsoft, Basic and Oasis'], kobo: ['Hands-free, one-handed reading', 'Left or right hand', 'Fits Kobo Clara and Libra'], ipad: ['Grip strap built into the case', 'Fits iPad and iPad mini', 'Hold it for hours without the ache'] };

  function models(device) { return cfg.models.filter(function (m) { return m.device === device; }); }
  function findModel(id) { return cfg.models.filter(function (m) { return m.id === id; })[0]; }
  function list(m) { return state.useCase && m.caseVariants && m.caseVariants.length ? m.caseVariants : m.variants; }
  function firstAvail(m) { var l = list(m); return l.filter(function (v) { return v.available; })[0] || l[0]; }

  function render() {
    var s = state;
    backBtn.style.visibility = s.step > 1 ? 'visible' : 'hidden';
    stepEl.textContent = 'Step ' + s.step + ' of 3';
    if (s.step === 1) {
      titleEl.textContent = 'What do you read on?';
      var sv = saved();
      bodyEl.innerHTML = '<div class="hp2-fit__grid hp2-fit__grid--3">' + ['kindle', 'kobo', 'ipad'].map(function (d) {
        return '<button type="button" class="hp2-fit__tile" data-device="' + d + '"><span style="font-size:15px">' + DEVICES[d].label + '</span></button>';
      }).join('') + '</div>' + (sv && sv.model ? '<p class="hp2-fit__help">Last time you picked: ' + esc(sv.label) + '.</p>' : '');
    } else if (s.step === 2) {
      titleEl.textContent = 'What ' + DEVICES[s.device].label + ' do you have?';
      var pts = POINTS[s.device] || [];
      bodyEl.innerHTML = (pts.length ? '<ul class="hp2-fit__points">' + pts.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ul>' : '') + '<div class="hp2-fit__grid">' + models(s.device).map(function (m, idx) {
        var v = firstAvail(m);
        var vl = list(m).filter(function (x) { return x.available; }); if (vl.length > 1) { v = vl[(idx + 1) % vl.length]; }
        return '<button type="button" class="hp2-fit__tile" data-model="' + esc(m.id) + '"><img src="' + esc(v.image) + '" alt="" width="200" height="200" decoding="async"><span>' + esc(m.label) + '<br><small>' + esc(m.sub) + '</small></span></button>';
      }).join('') + '</div><p class="hp2-fit__help">' + DEVICES[s.device].help + (DEVICES[s.device].video ? ' <a href="' + DEVICES[s.device].video + '" target="_blank" rel="noopener">Watch how</a>' : '') + '</p>';
    } else {
      var m = findModel(s.model), L = list(m), v = L.filter(function (x) { return x.id === s.variant; })[0] || firstAvail(m);
      titleEl.textContent = 'Your fit: ' + m.label;
      var stars = Number(m.product.count) > 0 ? '<div style="font-size:12px;color:#5d6678"><b style="color:#a67c00">★ ' + esc(Number(m.product.rating).toFixed(2)) + '</b> (' + esc(m.product.count) + ')</div>' : '';
      var cs = (m.caseVariants && m.caseVariants.length) ? '<label class="hp2-fit__case"><input type="checkbox" data-case' + (s.useCase ? ' checked' : '') + '> I’m using a Strapsicle Clear Case (we’ll bump you up a size)</label>' : '';
      var sw = L.length > 1 ? '<div class="hp2-fit__sw" role="radiogroup" aria-label="Colour">' + L.map(function (x) {
        return '<button type="button" role="radio" aria-checked="' + (x.id === v.id) + '" data-variant="' + x.id + '" title="' + esc(x.colour) + '" aria-label="' + esc(x.colour) + (x.available ? '' : ' (sold out)') + '"' + (x.available ? '' : ' disabled') + '><img src="' + esc(x.image) + '" alt="" width="40" height="40"></button>';
      }).join('') + '</div><div style="font-size:12px;color:#5d6678;margin-top:-8px">' + esc(v.colour) + '</div>' : '';
      var up = (m.device !== 'ipad' && cfg.pack && cfg.pack.url) ? '<a class="hp2-fit__up" href="' + esc(cfg.pack.url) + '">Add the Clutch' + (cfg.pack.percent > 0 ? ' and save ' + cfg.pack.percent + '%' : '') + ': ' + esc(cfg.pack.title) + ' · ' + esc(cfg.pack.price) + '</a>' : '';
      bodyEl.innerHTML = '<div class="hp2-fit__prod"><img src="' + esc(v.image) + '" alt="" width="110" height="110"><div><h3><a href="' + esc(m.product.url) + '" style="color:inherit">' + esc(m.product.title) + '</a></h3>' + stars +
        '<div class="hp2-fit__fits">✓ Fits ' + esc(m.label) + '</div><div class="hp2-fit__price">' + esc(v.price) + (v.compare ? '<s>' + esc(v.compare) + '</s>' : '') + '</div></div></div>' + cs + sw +
        '<button type="button" class="hp2-fit__atc" data-atc' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Add to cart' : 'Sold out') + '</button><div class="hp2-fit__msg" role="alert" data-msg></div>' + up +
        '<p class="hp2-fit__foot">We’ll remember your ' + esc(m.label) + ', so product pages open with it already selected.</p>';
    }
    if (state.focusBody) { var f = $('button:not([disabled])', bodyEl); if (f) f.focus(); }
  }

  function open(device, trigger) {
    lastFocus = trigger || document.activeElement;
    root.hidden = false; document.documentElement.style.overflow = 'hidden';
    titleEl.textContent = 'Loading…'; bodyEl.innerHTML = ''; stepEl.textContent = '';
    state = { step: 1, device: null, model: null, variant: null, focusBody: false, useCase: false, colour: (trigger && trigger.getAttribute && trigger.getAttribute('data-fit-colour')) || '' };
    sheet.focus();
    track('fit_finder_open', { fit_device: device || '' });
    loadConfig().then(function () {
      if (device && DEVICES[device]) { state.device = device; state.step = 2; track('fit_finder_device', { fit_device: device }); }
      render();
    }).catch(function () {
      titleEl.textContent = 'Find your fit';
      bodyEl.innerHTML = '<p>We couldn’t load the finder just now. <a href="/pages/strapsicle-size-guide">Open the size guide</a> instead.</p>';
    });
  }
  function close() {
    root.hidden = true; document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function cartAdd(id) {
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(base + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); });
  }

  function initFit() {
    root = $('#hp2-fit'); if (!root) return;
    sheet = $('.hp2-fit__sheet', root); bodyEl = $('[data-fit-body]', root); titleEl = $('[data-fit-title]', root); stepEl = $('[data-fit-step]', root); backBtn = $('[data-fit-back]', root);
    if (root.parentNode !== document.body) document.body.appendChild(root);

    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-fit-open]');
      if (t) { e.preventDefault(); open(t.getAttribute('data-fit-open') || '', t); return; }
      var a = e.target.closest && e.target.closest('a[href$="#find-my-fit"]');
      if (a) { e.preventDefault(); open('', a); }
    });
    ['touchstart', 'mouseover'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('[data-fit-open]')) loadConfig().catch(function () {}); }, { passive: true, once: true });
    });

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-fit-close]')) return close();
      if (t.closest('[data-fit-back]')) { state.step = Math.max(1, state.step - 1); if (state.step === 1) state.device = null; return render(); }
      var d = t.closest('[data-device]');
      if (d) { state.device = d.getAttribute('data-device'); state.step = 2; state.focusBody = true; track('fit_finder_device', { fit_device: state.device }); return render(); }
      var m = t.closest('[data-model]');
      if (m) {
        var mod = findModel(m.getAttribute('data-model'));
        state.model = mod.id; state.variant = firstAvail(mod).id; state.step = 3; state.focusBody = true;
        if (state.colour) { var pc = list(mod).filter(function (x) { return x.available && String(x.colour).toLowerCase() === state.colour.toLowerCase(); })[0]; if (pc) state.variant = pc.id; }
        save({ device: mod.device, model: mod.id, label: mod.label, sizeKey: mod.sizeKey });
        track('fit_finder_model', { fit_device: mod.device, fit_model: mod.id });
        return render();
      }
      var cb = t.closest('[data-case]');
      if (cb) {
        var cm = findModel(state.model), cur = list(cm).filter(function (x) { return x.id === state.variant; })[0];
        state.useCase = cb.checked; var nl = list(cm);
        var same = cur && nl.filter(function (x) { return x.colour === cur.colour && x.available; })[0];
        state.variant = (same || firstAvail(cm)).id; state.focusBody = false; return render();
      }
      var sw = t.closest('[data-variant]');
      if (sw) { state.variant = Number(sw.getAttribute('data-variant')); state.focusBody = false; return render(); }
      var atc = t.closest('[data-atc]');
      if (atc) {
        atc.disabled = true; atc.textContent = 'Adding…';
        cartAdd(state.variant).then(function () {
          track('fit_finder_add_to_cart', { fit_model: state.model, variant_id: state.variant });
          atc.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          setTimeout(function () { close(); document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); }, 350);
        }).catch(function (err) {
          atc.disabled = false; atc.textContent = 'Add to cart';
          var msg = $('[data-msg]', root); if (msg) msg.textContent = 'Couldn’t add that one: ' + err.message;
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); return close(); }
      if (e.key === 'Tab') {
        var f = $$('button:not([disabled]),a[href]', sheet).filter(function (x) { return x.offsetParent !== null && x.style.visibility !== 'hidden'; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (document.activeElement === first || document.activeElement === sheet)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  /* ---------- pre-select saved model on product pages (best effort) ---------- */
  function preselect() {
    var sv = saved();
    if (!sv || !sv.sizeKey || !$('form[action*="/cart/add"]')) return;
    var tries = 0, t = setInterval(function () {
      tries++;
      var radios = $$('input[type=radio]');
      var hit = radios.filter(function (i) { return i.value && i.value.indexOf(sv.sizeKey) === 0 && !i.checked; })[0];
      var done = radios.some(function (i) { return i.checked && i.value && i.value.indexOf(sv.sizeKey) === 0; });
      if (done || tries > 12) return clearInterval(t);
      if (hit) { hit.click(); clearInterval(t); }
    }, 400);
  }

  /* ---------- pop-up (waitlist): links to #id open the matching .hp2-modal ---------- */
  function initModals() {
    var openEl = null;
    function open(m, trigger) { openEl = trigger || document.activeElement; m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; var b = $('.hp2-modal__box', m); if (b) b.focus(); track('hp2_modal_open', { modal: m.id }); }
    function close(m) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (openEl && openEl.focus) { try { openEl.focus(); } catch (e) {} } }
    document.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-hp2-modal-close]');
      if (c) { var m = c.closest('.hp2-modal'); if (m) close(m); return; }
      var a = e.target.closest && e.target.closest('a[href*="#"]');
      if (!a) return;
      var id = a.getAttribute('href').split('#')[1], m2 = id && document.getElementById(id);
      if (m2 && m2.classList.contains('hp2-modal')) { e.preventDefault(); open(m2, a); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var m = $('.hp2-modal.is-open'); if (m) { e.preventDefault(); close(m); }
    });
    if (location.hash) { var h = document.getElementById(location.hash.slice(1)); if (h && h.classList.contains('hp2-modal')) open(h); }
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initTabs(); initVideos(); initHeroVideo(); initReel(); initSectionViews(); initFit(); initModals(); preselect(); });
})();

/* Homepage signup: send the email to Omnisend as a subscribed contact (same newsletter audience as the Join the Family form), then to Shopify. */
(function () {
  var f = document.querySelector('[data-hp2-signup]');
  if (!f) return;
  f.addEventListener('submit', function (e) {
    var em = f.querySelector('[name="contact[email]"]'), fn = f.querySelector('[name="contact[first_name]"]');
    var email = em && em.value.trim();
    if (!email || !f.checkValidity()) return;
    e.preventDefault();
    var first = fn ? fn.value.trim() : '';
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['identifyContact', {
      email: email, firstName: first, tags: ['newsletter', 'homepage-signup'],
      identifiers: [{ type: 'email', id: email, channels: { email: { status: 'subscribed', statusDate: new Date().toISOString() } } }]
    }]);
    var done = function () {
      f.hidden = true; var ok = document.querySelector('[data-hp2-signup-ok]'); if (ok) ok.hidden = false;
      if (window.dataLayer) window.dataLayer.push({ event: 'hp2_signup' });
    };
    try { fetch(f.action, { method: 'POST', body: new FormData(f), credentials: 'same-origin' }).then(done, done); } catch (err) { done(); }
  });
})();
